import { base } from "./_internal";

/**
 * FileError
 */
export class FileError extends base.ApplicationError {
	public static override readonly code: number = 480;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "File error");
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * DirectoryNotEmptyError
 */
export class DirectoryNotEmptyError extends FileError {
	public static override readonly code: number = 481;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Directory not empty");
		Object.setPrototypeOf(this, trueProto);
	}
}
